import React from 'react'
import Options from './Options'
import { trans } from '../../../../../_providers/Translation'
import loader from '../../../../../assets/img/loader.svg'
import { Checkbox } from '@mui/material'

function TableFiles(props) {

    const markToIncludeInOffer = (e, id) => {
        props.setSelectedFilesIds(prev =>
            e.target.checked ? [...prev, id] : prev.filter(x => x !== id)
        )
    }

    const includeAllInOffer = (e) => {
        const checked = e.target.checked

        if (checked) {
            const allIds = props.data.map(row => row.id)
            props.setSelectedFilesIds(allIds)
        } else {
            props.setSelectedFilesIds([])
        }
    }

    return (
        props.loading
            ?
            <img src={loader} alt="loading" />
            :
            <>
                {props.data.length == 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noResultsFound')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th
                                        className="checkbox"
                                    >
                                        <Checkbox
                                            checked={props.selectedFilesIds.length > 0 && props.selectedFilesIds.length === props.data.length}
                                            indeterminate={props.selectedFilesIds.length > 0 && props.selectedFilesIds.length < props.data.length}
                                            onChange={(e) => includeAllInOffer(e)}
                                            size='small'
                                        />
                                    </th>
                                    <th>ID</th>
                                    <th>{trans('labels.file')}</th>
                                    {props.reservation?.can_modify &&
                                        <th
                                            className="options"
                                            style={{
                                                paddingRight: '20px'
                                            }}
                                        >
                                            {trans('tables.options')}
                                        </th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map(row =>
                                    <tr key={'f-' + row.id}>
                                        <td
                                            style={{
                                                paddingLeft: '20px'
                                            }}
                                            className="checkbox"
                                        >
                                            <Checkbox
                                                className="select-file-to-attach"
                                                checked={props.selectedFilesIds.includes(row.id)}
                                                onChange={(e) => markToIncludeInOffer(e, row.id)}
                                                data-id={row.id}
                                                size='small'
                                            />
                                        </td>

                                        <td>
                                            {row.id}
                                        </td>

                                        <td>
                                            <a class="btn" target="_blank" href={`${process.env.REACT_APP_API_URL}/storage/${row.filepath.replace('public/', '')}`}>{row.filename}</a>
                                        </td>

                                        {props.reservation?.can_modify &&
                                            <td
                                                className='center'
                                                style={{
                                                    paddingRight: '20px'
                                                }}
                                            >
                                                <Options
                                                    id={row.id}
                                                    deletable={true}
                                                    editable={false}
                                                    handleDeletePart={props.handleDeletePart}
                                                    handleEditPart={props.handleEditPart}
                                                />
                                            </td>
                                        }

                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </>
    )
}

export default TableFiles